import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable, DataTableFilterMeta } from "primereact/datatable";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { ADMIN_ROUTES } from "../../../../constants/routes/admin/menus";

import { FilterMatchMode } from "primereact/api";
import { AppDispatch } from "../../../../store";
import { Toolbar } from "primereact/toolbar";
import { retrieveResumes, retrieveResumeUploads, uploadResumes } from "../ResumeAction";
import LinkButton from "../../../../constants/helpers/LinkButton";
import FileUploader from "../../../../CandidatePortal/scenes/company/components/FileUploader";
import { Dialog } from "primereact/dialog";
import { ResumeUpload, ResumeUploadStatus } from "../interface";
import { Divider } from "primereact/divider";
import { Badge } from "primereact/badge";
import { Dropdown } from "primereact/dropdown";

interface ResumeUploadManagementProps {
}

const ResumeUploadManagement = (props: ResumeUploadManagementProps) => {
  const { } = props
  const toast = useRef<any>()
  const dt = useRef<any>(null)
  const history = useHistory()

  const [displayResumeUploadItem, setDisplayResumeUploadItem] = useState<ResumeUpload | undefined>(undefined)

  const dispatch = useDispatch<AppDispatch>()
  const { resumeUploadList, totalRecords, resumeUploading } = useSelector((state: any) => state.resume)

  let filters: DataTableFilterMeta = {
    fullName: { value: null, matchMode: FilterMatchMode.EQUALS },
    contactNumber: { value: null, matchMode: FilterMatchMode.EQUALS },
    email: { value: null, matchMode: FilterMatchMode.EQUALS },
    nationality: { value: null, matchMode: FilterMatchMode.EQUALS },
    totalYearsOfExperiences: { value: null, matchMode: FilterMatchMode.EQUALS },
    status: { value: null, matchMode: FilterMatchMode.EQUALS },
    createdDate: { value: null, matchMode: FilterMatchMode.EQUALS },
  }
  const [rows, setRows] = useState(5)
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: "createdDate",
    sortOrder: -1,
    filters
  })
  const [selectedStatus, setSelectedStatus] = useState(null)

  //Lazy loading
  useEffect(() => {
    dispatch(retrieveResumeUploads(lazyParams))
  }, [lazyParams])

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;
    console.log('uploading', resumeUploading)

    if (resumeUploading) {
      intervalId = setInterval(() => {
        dispatch(retrieveResumeUploads(lazyParams));
      }, 5000);
    } else {
      if (intervalId) {
        clearInterval(intervalId);
      }
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [resumeUploading]);

  // Custom Filter Details
  const [selectedDate, setSelectedDate] = useState(undefined)

  const onPage = (event: any) => {
    setRows(event.rows)
    let _lazyParams = { ...lazyParams, ...event }
    setLazyParams(_lazyParams)
  }

  const onSort = (event: any) => {
    let _lazyParams = { ...lazyParams, ...event }
    setLazyParams(_lazyParams)
  }

  const onFilter = (event: any) => {
    let _lazyParams = { ...lazyParams, ...event }
    _lazyParams['first'] = 0;
    setLazyParams(_lazyParams)
  }

  const onDateChange = (e: any) => {
    setSelectedDate(e.value)
    if (e.value[0] != null && e.value[1] != null) {
      let startDate = `${e.value[0].getFullYear()}-${e.value[0].getMonth() + 1}-${e.value[0].getDate()}`
      let endDate = `${e.value[1].getFullYear()}-${e.value[1].getMonth() + 1}-${e.value[1].getDate() + 1}`
      let _lazyParams = { ...lazyParams }
      _lazyParams.filters.createdDateLt = { 'value': startDate, matchMode: FilterMatchMode.EQUALS }
      _lazyParams.filters.createdDateGt = { 'value': endDate, matchMode: FilterMatchMode.EQUALS }
      setLazyParams(_lazyParams)
    }
  }
  
  const onStatusChange = (e: any) => {
    setSelectedStatus(e.value)
    let _lazyParams = { ...lazyParams }
    _lazyParams.filters.status = { value: e.value, matchMode: FilterMatchMode.EQUALS }
    setLazyParams(_lazyParams)
  }

  const dateFilter = <Calendar value={selectedDate} readOnlyInput selectionMode="range" onChange={onDateChange} dateFormat="yy-mm-dd" className="p-column-filter" placeholder="YYYY-MM-DD"></Calendar>
  const statuses = Object.keys(ResumeUploadStatus).filter(k => isNaN(Number(k)));
  const statusFilter = <Dropdown value={selectedStatus} options={statuses} onChange={onStatusChange} placeholder="All" className="p-column-filter" showClear></Dropdown>
  
  const handleResetFilters = () => {
    setSelectedDate(undefined)
    dt.current.reset();
    let _lazyParams = { ...lazyParams }
    _lazyParams.filters = {}
    setLazyParams(_lazyParams)
  }

  const toolbar = (
    <Button type="button" label="Clear" className="p-button-outlined" icon="pi pi-filter-slash" onClick={handleResetFilters} />
  )

  const createdDateBodyTemplate = (rowData: any) => {
    let date = new Date(rowData.createdDate)
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
  }
  
  const getStatusStyling = (rowData: any) => {
    switch (rowData.status) {
      case ResumeUploadStatus.PENDING:
        return <Badge value={rowData.status} severity="info"></Badge>
      case ResumeUploadStatus.COMPLETED:
        return <Badge value={rowData.status} severity="success"></Badge>
    }
  }

  const viewResumeUploadTemplate = (rowData: any) => {
    return (
      <div>
        <Button icon="pi pi-eye" className="p-button-secondary mr-2" onClick={() => setDisplayResumeUploadItem(rowData)}></Button>
      </div>
    )
  }

  const uploadResume = async (formData: FormData) => {
    await dispatch(uploadResumes(formData)).then(() => {
      toast.current.show({
        severity: 'success',
        summary: 'Success',
        detail: 'Resume uploaded successfully',
        life: 3000
      });

      // refresh table
      dispatch(retrieveResumeUploads(lazyParams))
      setLazyParams({ ...lazyParams, first: 0 })
    }).catch((error: any) => {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to upload resume: ' + error,
        life: 3000
      });
    });
  }

  const loading = () => {
    return resumeUploading ? (
      <>
        <i className="pi pi-spin pi-spinner mr-2"></i> Table will be automatically refreshed every 5 seconds.
      </>
    ) : null;
  }

  return (
    <div>
      <Toast ref={toast} />
      <div className="grid">
        <div className="col-12 mb-2 flex align-items-center justify-content-center">
          <FileUploader headerText="" multipleUpload={true} uploadResume={uploadResume} />
        </div>
        <div className="col-12 mb-2">
          <div className="card">
            <Toolbar className="p-mb-4" start={toolbar} end={loading}></Toolbar>
            <DataTable ref={dt} value={resumeUploadList} first={lazyParams.first} rows={rows} totalRecords={totalRecords}
              onPage={onPage} onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder as any}
              onFilter={onFilter} filters={lazyParams.filters} filterDisplay="row"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" rowsPerPageOptions={[5, 10, 25]}
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
              lazy paginator>
              <Column field="totalUploadsCount" header="Total Uploaded" filter sortable></Column>
              <Column field="successfulUploadsCount" header="Success Upload" filter sortable></Column>
              <Column field="failedUploadsCount" header="Failed Upload" filter sortable></Column>
              <Column field="status" header="Status" body={getStatusStyling} filter filterElement={statusFilter} sortable></Column>
              <Column field="createdDate" header="Created Date" body={createdDateBodyTemplate} filter filterElement={dateFilter} sortable></Column>
              <Column body={viewResumeUploadTemplate} headerStyle={{ width: '6em', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} />
            </DataTable>
          </div>
        </div>
      </div>
      <Dialog visible={displayResumeUploadItem !== undefined} onHide={() => setDisplayResumeUploadItem(undefined)} header="Resume Upload Details" style={{ width: '50vw' }}>
        {displayResumeUploadItem && (
          <div>
            <div>
              <h3>Successful Uploads</h3>
              <div className="grid">
                {displayResumeUploadItem.successfulUploads?.length ? (
                  displayResumeUploadItem.successfulUploads?.map((resume, index) => (
                    <Link key={index} to={'/resumes/' + resume.id} className="col-12 p-mb-1">{resume.fullName}</Link>
                  ))
                ) : (
                  <div className="col-12 font-italic">No successful uploads.</div>
                )}
              </div>
            </div>

            <Divider />

            <div>
              <h3>Failed Uploads</h3>
              <div className="grid">
                <div className="col-5">
                  <b>File</b>
                </div>
                <div className="col-7">
                  <b>Error</b>
                </div>
              </div>
              {displayResumeUploadItem.failedUploads?.length ? (
                displayResumeUploadItem.failedUploads?.map((file, index) => (
                  <div key={index} className="grid">
                    <div className="col-5 p-mb-1">{file}</div>
                    <div className="col-7 p-mb-1">{displayResumeUploadItem.errors && displayResumeUploadItem.errors[index]}</div>
                  </div>
                ))
              ) : (
                <div className="font-italic">No failed uploads.</div>
              )}
            </div>
          </div>
        )}
      </Dialog>
    </div>
  )
}

export default ResumeUploadManagement

